import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { IObject } from 'types';
import { FiasSearchProps } from '../../../../../../types';
import { OptionsList } from './components';
import { ScrollWrapper, EmptyList } from './menu-options.styled';

type MenuOptionsProps = {
  options: IObject[];
} & Pick<
  FiasSearchProps,
  'flat' | 'withSectors' | 'selectOnlyHouses' | 'disabledHouses'
>;

export const MenuOptions: FC<MenuOptionsProps> = observer(
  ({ options, flat, selectOnlyHouses, withSectors, disabledHouses }) => {
    const { fias } = useStore();

    return (
      <ScrollWrapper>
        {options.length ? (
          <OptionsList
            items={options}
            flat={flat}
            selectOnlyHouses={selectOnlyHouses}
            disabledHouses={disabledHouses}
          />
        ) : (
          <EmptyList>
            {(withSectors
              ? !fias.houseGroupsWithSectors.length
              : !fias.houseGroups.length) &&
            fias.currentFiasSearchType === 'groups'
              ? 'Группы не созданы. Вы можете создать группы домов в настройках'
              : 'По вашему запросу ничего не найдено. Попробуйте изменить условия поиска.'}
          </EmptyList>
        )}
      </ScrollWrapper>
    );
  }
);
